<mat-stepper [linear]=true #stepper>
  <ng-template matStepperIcon="edit">
    <mat-icon>done</mat-icon>
  </ng-template>
  <mat-step [stepControl]="firstFormGroup" label="Seleccionar actividades">
    <rpe-vinculacion-rol-actividad-listado [formInput]="data"
                                           (formValueChanges)="formValueChanges($event)"
                                           (formStatusChanges)="formStatusChanges($event)"
    ></rpe-vinculacion-rol-actividad-listado>
    <button mat-raised-button color={{data.cancelColor}} (click)="onCancel()">{{ data.cancelText}}</button>
    <button mat-raised-button color={{data.submitColor}} (click)="onSiguiente()" matStepperNext>Siguiente</button>
  </mat-step>
  <mat-step   label="Aprobar consentimiento informado">
    <rpe-consentimiento-informado [formInput]="data"></rpe-consentimiento-informado>
    <button mat-button matStepperPrevious (click)="stepper.previous()">Atrás</button>
    <button mat-raised-button color={{data.cancelColor}} (click)="onCancel()">{{ data.cancelText}}</button>
    <button type="submit" mat-raised-button (click)="onSubmit()" color={{data.submitColor}}>{{ data.submitText}}</button>
  </mat-step>
</mat-stepper>








































<!--<div class="row justify-content-center" [ngClass]="routeAnimationsElements">-->
<!--  <mat-card>-->

<!--    <div *ngIf="esSeccionListadoActividad">-->
<!--      <rpe-vinculacion-rol-actividad-listado [formInput]="data"></rpe-vinculacion-rol-actividad-listado>-->
<!--    </div>-->

<!--    <div *ngIf="esSeccionConsentimientoInformado">-->
<!--      <rpe-consentimiento-informado [formInput]="data"></rpe-consentimiento-informado>-->
<!--    </div>-->




<!--    <div class="row buttons d-flex justify-content-between pad" [ngClass]="routeAnimationsElements">-->
<!--      <button type="reset" (click)="onCancel()" mat-raised-button color={{data.cancelColor}}>-->
<!--        {{ data.cancelText}}-->
<!--      </button>-->
<!--      <button type="submit" mat-raised-button (click)="onSubmit()" color={{data.submitColor}}>-->
<!--        {{ data.submitText}}-->
<!--      </button>-->
<!--    </div>-->

<!--  </mat-card>-->
<!--</div>-->

